import { Label, Svg, SvgName } from "@ac-expo/ui-components";

type PasswordCheckProps = {
  desc: string;
  errorType: string;
  toDisplay: boolean;
  passwordError: string | undefined;
};

function getSvgNameAndTextColor(
  toDisplay: boolean,
  passwordError: string | undefined,
  errorType: string
): { svg_name: SvgName; text_color: string } {
  if (!toDisplay && !passwordError)
    return { svg_name: "gray_dot", text_color: "text-gray-500" };
  if (!toDisplay && passwordError)
    return { svg_name: "red_cross", text_color: "text-red-500" };
  if (passwordError?.includes(errorType))
    return { svg_name: "red_cross", text_color: "text-red-500" };
  return { svg_name: "green_check", text_color: "text-success" };
}

export function PasswordCheck({
  desc,
  toDisplay,
  passwordError,
  errorType,
}: PasswordCheckProps) {
  const { svg_name, text_color } = getSvgNameAndTextColor(
    toDisplay,
    passwordError,
    errorType
  );

  return (
    <div className="flex gap-3">
      <Svg name={svg_name} alt={svg_name} />
      <Label className={text_color}>{desc}</Label>
    </div>
  );
}

export default PasswordCheck;
